import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  inner: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  },
  outer: {
    position: "relative",
    overflow: "scroll",
    flex: 1,
    zIndex: 1
  }
}));

export default function ScrollContainer(props) {
  const classes = useStyles();
  const Inner = props.inner || "div";
  const Outer = props.outer || "div";
  return (
    <Outer className={classes.outer}>
      <Inner className={classes.inner}>{props.children}</Inner>
    </Outer>
  );
}
